/**
 * 灵犀统计，前端埋点
 */
import { env } from './env';

class Analytics {
  private static readonly environment = null;

  private readonly commonParams = {};

  constructor(params: any) {
    this.commonParams = params;
  }

  static getTraceParams() {
    return {
      payRequestId: env.payRequestId,
      mTraceId: env.traceId,
    };
  }

  pv(cid: string, lab = {}) {
    if ('LXAnalytics' in window && cid) {
      window.LXAnalytics(
        'pageView',
        {
          custom: {
            ...this.commonParams,
            ...Analytics.getTraceParams(),
            ...lab,
          },
        },
        Analytics.environment,
        cid
      );
    }
  }

  click(bid: string, lab = {}, opts = {}) {
    if ('LXAnalytics' in window && bid) {
      window.LXAnalytics(
        'moduleClick',
        bid,
        {
          ...this.commonParams,
          ...Analytics.getTraceParams(),
          ...lab,
        },
        {
          ...opts,
        }
      );
    }
  }

  mv(bid: string, lab = {}, opts = {}) {
    if ('LXAnalytics' in window && bid) {
      window.LXAnalytics(
        'moduleView',
        bid,
        {
          ...this.commonParams,
          ...Analytics.getTraceParams(),
          ...lab,
        },
        {
          ...opts,
        }
      );
    }
  }

  sc(bid: string, lab = {}, opts = {}) {
    if ('LXAnalytics' in window && bid) {
      window.LXAnalytics(
        'systemCheck',
        bid,
        {
          ...this.commonParams,
          ...Analytics.getTraceParams(),
          ...lab,
        },
        {
          ...opts,
        }
      );
    }
  }

  addTag(tagObj: any, cid: string) {
    const options = {
      [cid]: {
        ...this.commonParams,
        ...tagObj,
      },
    };
    if ('LXAnalytics' in window && cid) {
      window.LXAnalytics('tag', 'pay', options);
    }
  }
}

const commonParams = {
  ...env.commonParams,
  entry: env.entry,
  mtPlanId: env.mtPlanId,
  utm_source: env.utmSource || '-999',
  style_type: env.openPageStyle || '-999',
};
export const analytics = new Analytics(commonParams);
